import { render } from "./ConsultoriaYAsesoriaDeIngenieria.vue?vue&type=template&id=818a218a&scoped=true"
import script from "./ConsultoriaYAsesoriaDeIngenieria.vue?vue&type=script&lang=js"
export * from "./ConsultoriaYAsesoriaDeIngenieria.vue?vue&type=script&lang=js"

import "./ConsultoriaYAsesoriaDeIngenieria.vue?vue&type=style&index=0&id=818a218a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-818a218a"]])

export default __exports__